module.exports = __webpack_public_path__ + "img/PL00105.927959c3.png";